import { render, staticRenderFns } from "./settledXMYTab.vue?vue&type=template&id=abf10e96&scoped=true&"
import script from "./settledXMYTab.vue?vue&type=script&lang=js&"
export * from "./settledXMYTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf10e96",
  null
  
)

export default component.exports